import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { SharedService } from 'src/app/auth/shared.service';
import { CobrancaJudicial } from 'src/app/base/domain/cobranca-judicial.model';
import { Posto } from 'src/app/base/domain/posto.model';
import { Usuario } from 'src/app/base/domain/usuario.model';
import { QueryOptions } from '../../domain/query.options';

export interface CobrancaJudicialAcaoEvent {
  acao: string;
  cobranca: CobrancaJudicial;
}

export interface CobrancaJudicialMenuAcaoEvent {
  acao: string;
}

export interface CobrancaJudicialListFilterOptions {
  nomeCliente: string;
  postoSelecionado: Posto;
  dataInicial: Date;
  dataFinal: Date;
}

@Component({
  selector: 'app-cobranca-judicial-list',
  templateUrl: './cobranca-judicial-list.component.html',
  styleUrls: ['./cobranca-judicial-list.component.css']
})
export class CobrancaJudicialListComponent implements OnInit {
  @Input() title: string;
  @Input() cobrancas: CobrancaJudicial[];
  @Input() totalRecords: number;
  @Input() rowsNumber: number;
  @Input() filtros: string[];
  @Input() options: string[];
  @Input() loading: boolean;
  @Input() menuAcoes: string[];

  @Output() filter = new EventEmitter<CobrancaJudicialListFilterOptions>();
  @Output() loadPage = new EventEmitter<number>();
  @Output() acaoClick = new EventEmitter<CobrancaJudicialAcaoEvent>();
  @Output() disclosure = new EventEmitter<CobrancaJudicial>();
  @Output() menuAcaoClickEvent = new EventEmitter<CobrancaJudicialMenuAcaoEvent>();


  shared: SharedService;
  usuario: Usuario;

  private currentPage = 0;
  queryOptions = new QueryOptions();

  private readonly defaultFilterOptions: CobrancaJudicialListFilterOptions = {
    nomeCliente: '',
    postoSelecionado: null,
    dataInicial: null,
    dataFinal: null,
  };

  filterOptions: CobrancaJudicialListFilterOptions;

  ngOnInit(): void {
    this.onLimparFiltros();
  }

  load(event: LazyLoadEvent): void {
    const pageNumber = Math.floor(event.first / event.rows);
    this.currentPage = pageNumber;
    this.loadPage.emit(pageNumber);
  }

  onDisclosure(equipe: CobrancaJudicial): void {
    this.disclosure.emit(equipe);
  }

  onAcaoClick(acao: string, domain: CobrancaJudicial): void {
    this.acaoClick.emit({ acao, cobranca: domain });
  }

  onAtualizar(): void {
    this.loadPage.emit(this.currentPage);
  }

  onLimparFiltros(): void {
    this.filterOptions = Object.assign({}, this.defaultFilterOptions);
  }

  onAplicarFiltro(): void {
    this.filter.emit(this.filterOptions);
  }

  generateMask(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }



}
